import {
  FolderOpenOutlined,
  EnvironmentOutlined,
  ContainerOutlined,
  PrinterOutlined,
  EditOutlined,
  BookOutlined,
  UserOutlined,
  FileDoneOutlined,
  PlusCircleOutlined,
  BankOutlined,
  BarChartOutlined,
  MessageOutlined,
} from "@ant-design/icons";

const Icons = {
  FolderOpenOutlined,
  EnvironmentOutlined,
  ContainerOutlined,
  PrinterOutlined,
  EditOutlined,
  BookOutlined,
  UserOutlined,
  BankOutlined,
  FileDoneOutlined,
  PlusCircleOutlined,
  BarChartOutlined,
  MessageOutlined,
};

export default Icons;
